module.exports = __webpack_public_path__ + "static/media/6 Seats 7 Sides doubled sided sides.e528a3aa.png";